var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_61011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 12.0004L11.7615 15.2144C11.849 15.2582 11.8927 15.28 11.9385 15.2886C11.9792 15.2963 12.0209 15.2963 12.0615 15.2886C12.1073 15.28 12.1511 15.2582 12.2385 15.2144L18.6667 12.0004M5.33334 15.3337L11.7615 18.5478C11.849 18.5915 11.8927 18.6134 11.9385 18.622C11.9792 18.6296 12.0209 18.6296 12.0615 18.622C12.1073 18.6134 12.1511 18.5915 12.2385 18.5478L18.6667 15.3337M5.33334 8.66704L11.7615 5.45296C11.849 5.40923 11.8927 5.38737 11.9385 5.37876C11.9792 5.37114 12.0209 5.37114 12.0615 5.37876C12.1073 5.38737 12.1511 5.40923 12.2385 5.45296L18.6667 8.66704L12.2385 11.8811C12.1511 11.9248 12.1073 11.9467 12.0615 11.9553C12.0209 11.9629 11.9792 11.9629 11.9385 11.9553C11.8927 11.9467 11.849 11.9248 11.7615 11.8811L5.33334 8.66704Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_61011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorIcon);
export default __webpack_public_path__ + "static/media/floor_icon.a706f35a22926a6c0db334ea09e6c56e.svg";
export { ForwardRef as ReactComponent };